<template>
  <div class="purchase-page">
      <div class="app-down flex-between" v-if='$route.query.isApp!=1'>
      <div class="flex-center">
        <img src="../../../static/images/logo_download.svg" alt />
        <div class="download-content">
          <p>SuperEx APP</p>
          <span class="block">{{$t('300261')}}</span>
        </div>
      </div>
      <div class="flex-center">
        <dl @click="$router.push({path:'/download',query:{type:'purchase'}})">
          <dt>
        <svg>
          <use xlink:href='#icon-xiazaitubiao1'></use>
         </svg>
          </dt>
          <dd>{{$t('300345')}}</dd>
        </dl>
      </div>
    </div>
    <headerTop v-if='$route.query.isApp!=1'></headerTop>
    <!-- <div class="purchase-header" v-if="$route.query.isApp!=1">
      <i @click="goBack" class="iconfont icon-left" :class="{mirrorRotateLevel:isDirection}"></i>
    </div> -->
    <div class="purchase-body">
      <van-skeleton class='swiperSkeleton' :row="1" :loading="loading">
      <div class="swiper-banner" v-if="swipeConfig.length>0">
        <van-swipe :autoplay="3000">
          <van-swipe-item v-for="image in swipeConfig" @click.stop="$router.push({path:image.link,query:{banner:true,isApp:$route.query.isApp}})" :key="image.id">
            <img :src="image.image" />
          </van-swipe-item>
        </van-swipe>
      </div>
</van-skeleton>

      <div class="winners">
        <div class="nav-bar">
          <!-- 购买记录 -->
          <span class="bold">{{$t('300299')}}</span>
          <span @click="lookHistory">{{$t('300298')}}</span>
        </div>
        <div class="notice">
          <van-skeleton class='lamp1Skeleton' :row="1" :loading="loading1">
             <div class="notice-lamp1" v-if="prizeUser.length>0">
            <horse-lamps speed="50">
              <ul class="trotting-horse-lamp1 ul50">
                <li v-for="(item,index) in prizeUser" :key="index">
                  <img
                    :class="{mirrorRotateLevel:isDirection}"
                    src="../../../static/images/congratulations.png"
                    alt
                  />
                  {{item.message}}
                </li>
              </ul>
            </horse-lamps>
          </div>
          </van-skeleton>
         <van-skeleton class='lamp2Skeleton' :row="1" :loading="loading2">
           <div class="notice-lamp2" v-if="joinUser.length>0">
            <horse-lamps speed="80">
              <ul class="trotting-horse-lamp2 ul80">
                <li v-for="(item,index) in joinUser" :key="index">
                  <img
                    :class="{mirrorRotateLevel:isDirection}"
                    src="../../../static/images/congratulations.png"
                    alt
                  />
                  {{item.message}}
                </li>
              </ul>
            </horse-lamps>
          </div>
         </van-skeleton>

        </div>
      </div>
      <div class='purchase-toast' v-if='buySuccess'>
        <lottie class='lottie' :options='shopMessage.status==1&&num==1?defaultOptions:towOptions'></lottie>
        <p class='bold'>{{tipMessage}}</p>
      </div>
      <!-- 商品列表 -->
      <!-- <p class="bold shopList">
        <img src="../../../static/images/lefticon.png" alt />{{$t('300299')}}<img src="../../../static/images/righticon.png" alt />
      </p>-->

       <van-skeleton class='productListSkeleton' :row="1" :loading="loading3">
      <div class="product-list" transition-duration="0s" v-masonry>
        <div class='product-outbox'
         v-for='item in shopList'
         v-masonry-tile
        :class="`demo-${item.id}`"
        gutter="20"
         :key='item.id'
         >
        <div
         class="product-item"
          @click="goDetail(item)"
        >
          <img :src="item.img" alt />
          <div class="shop-describe">
            <p class="product-title bold">{{item.title}}</p>
            <div class="progress-bar" v-if="item.sellCount">
              <div :style="{width:(item.sellCount/(item.price/item.minPrice))*100+'%'}" class="rate-of-progress"></div>
            </div>
             <div class="progress-bar" v-if="!item.sellCount">
              <div class="rate-of-progress"></div>
            </div>
            <p class="current-price bold">
              {{$t('300334')}}&nbsp;
              <span>{{item.minPrice}}{{item.currency.toUpperCase()}}</span>
            </p>
            <p class="old-price">{{item.price}}{{item.currency.toUpperCase()}}</p>
            <!-- 立即参与 -->
              <van-button class="bold"
          v-if="item.status===1" @click.stop="handler(item)">{{$t('300302')}}</van-button>
            <van-button class="bold alignBtn"
          v-if="item.status===2" @click.stop="handler(item)">{{$t('300303')}}</van-button>
          </div>
        </div>
        </div>
        </div>
        <div class="loading-box" v-show="isShow">
           </div>
        </van-skeleton>
      <!-- </div> -->
    </div>
    <!-- <rulePopup :show="show" :content='content' :colseFun="closePopup"></rulePopup> -->
    <!-- 购买弹框 -->
    <van-popup class="form-popup" :close-on-click-overlay="false" position="bottom" v-model="show">
      <p class="Copies flex-between">
        <!-- 选择购买份数 -->
        <span class="bold">{{$t('300304')}}</span>
        <i @click="show = false" class="iconfont icon-guanbi1"></i>
      </p>
      <p
        class="price"
        v-html="$t('300305',{minPrice:shopMessage.minPrice,currency:shopMessage.currency.toUpperCase(),maxBuyCount:shopMessage.maxBuyCount})"
      ></p>
      <div class="inputBox">
        <span @click="subtractNum" class="subtract bold inline-block" :class="{disable:num<=1}">—</span>
        <div class="input">
          <p>
            <input @input="handleInput" maxlength="4" v-model="num" type="text" />
            {{$t('300306')}}
          </p>
          <p>{{$t('300318',{num:fixedNum(shopMessage.minPrice,num),currency:shopMessage.currency.toUpperCase()})}}</p>
        </div>
        <span @click="addNum" class="add bold inline-block">+</span>
      </div>
      <div class="prizeDescribe">
        <!-- 购买份数越多购买成功概率越大 -->
        <p>{{$t('300307',{num:assetsNum,currency:shopMessage.currency.toUpperCase()})}}</p>
      </div>
      <div class="buy">
        <van-button
          @click.stop="buyShop(shopMessage.id)"
          :disabled="num==''||num==0"
          class="bold"
          type="default"
        >{{$t('300308')}}</van-button>
        <!-- 购买 -->
      </div>
    </van-popup>
    <!-- 余额不足 -->
    <van-popup class="tipModel" :close-on-click-overlay="false" v-model="tipModel">
      <p class="p">
        <svg>
          <use xlink:href="#icon-tishi-1" />
        </svg>
      </p>
      <p class="describe bold inline-block">{{tipMessage}}</p>
      <div class="btn inline-block">
        <!-- 错失良机 -->
        <van-button @click="tipModel=false">{{$t('300309')}}</van-button>
        <!-- 余额充值 -->
        <van-button @click="rechargeBalance">{{$t('300297')}}</van-button>
      </div>
    </van-popup>
    <!-- 购买成功的奖品 -->
    <van-popup class="prizeModel" :close-on-click-overlay="false" v-model="prizeModel">
      <p class="p">
        <!-- 恭喜您 -->
        <img
          class="mirrorRotateLevel"
          src="../../../static/images/congratulations.png"
          alt
        />

        {{$t('300310')}}
       <img src="../../../static/images/congratulations.png" alt />
      </p>
      <p class="shopName bold">{{prizeMessage.snapshotTitle}}</p>
      <p class="prizeImage">
        <img src="../../../static/images/prize.png" alt />
      </p>
      <div class="btn inline-block" v-if='$route.query.isApp==1'>
        <van-button class="bold" @click='showOff'>{{$t('300346')}}</van-button>
        <!-- 炫耀一下-->
          <div class='tipsMessage'>
          <p>{{$t('300349')}} </p>
          <p>{{$t('300350')}}</p>
        </div>
      </div>
       <div class='tipsMessage' v-if='$route.query.isApp!=1'>
           <p>{{$t('300349')}} </p>
          <p>{{$t('300350')}}</p>
        </div>
      <div class="close">
        <svg @click="closePrize">
          <use xlink:href="#icon-guanbi2" />
        </svg>
      </div>
    </van-popup>
    <!-- 商品被购买走 -->
    <tips-model :show="tipsdialog" :content="tipMessage" :colseFun="closeTips"></tips-model>
    <van-popup class="tipModel" :close-on-click-overlay="false" v-model="selled">
      <p class="p">
        <svg>
          <use xlink:href="#icon-tishi-1" />
        </svg>
      </p>
      <p class="describe bold inline-block">{{tipMessage}}</p>
      <div class="sell inline-block">
        <!-- 再试一次 -->
        <van-button @click="selled=false">{{$t('300312')}}</van-button>
      </div>
    </van-popup>
    <van-popup class="tipModel" :close-on-click-overlay="false" v-model="rechargeModel">
      <p class="p">
        <svg>
          <use xlink:href="#icon-tishi-1" />
        </svg>
      </p>
      <!-- 请在APP上执行充值或者P2P入金操作 -->
      <p class="recharge inline-block">{{$t('300313')}}</p>
      <div class="sell inline-block">
        <van-button @click="rechargeModel=false">{{$t('300286')}}</van-button>
      </div>
    </van-popup>
    <!-- 领取商品 -->
    <van-popup class="tipModel" :close-on-click-overlay="false" v-model="getPrize">
      <p class="p">
        <svg>
          <use xlink:href="#icon-tishi-1" />
        </svg>
      </p>
      <p class="recharge inline-block">{{$t('300315')}}</p>
      <div class="sell inline-block">
        <van-button @click="getPrize=false">{{$t('300286')}}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Button, NoticeBar, Popup, Toast, NavBar, Swipe, SwipeItem,Skeleton  } from 'vant';
import { mapGetters } from 'vuex';
import TipsModel from "./compontents/tipsModel.vue";
import headerTop from "../../compontents/headerTop";
import Methods from '../../utils/methods'
import { getLanguageList } from "../../api/user";
import onceBuy from '../../../static/animationData/one.json'
import twiceBuy from '../../../static/animationData/more.json'
import HorseLamps from "./compontents/horselamps.vue"
// import commonTipsModel from './compontents/commonTipModels.vue'

import {
  setCookie,
  removeCookie,
  removeToken,
  getCookie,
  setToken,
  removeLanguage
} from "../../utils/auth";
import { getHorseLamp, getShopData, getUserAssets, buyPrizeShop, askShopStatus,getPurchaseBanner} from './api';
// import rulePopup from "./compontents/popup.vue"
export default {
  name: 'homePage',
  components: {
    VanButton: Button,
    VanNoticeBar: NoticeBar,
    VanPopup: Popup,
    TipsModel,
    VanNavBar: NavBar,
    HorseLamps,
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem,
    headerTop,
    VanSkeleton:Skeleton
    // rulePopup
  },
  data() {
    return {
      defaultOptions: { animationData: onceBuy,loop:false },
      towOptions:{ animationData:twiceBuy,loop:false},
      prizeUser: [],
      show: false,
      content: '',
      num: 1,
      isApp: '',
      tipModel: false,//余额不足
      prizeModel: false,//中将弹框
      tipsdialog: false,//参与成功弹框
      selled: false,//商品已售卖
      horseLampList: [],//走马灯数据
      shopMessage: {
        currency: ''
      },//商品详情信息
      assetsNum: 0,
      shopList: [],
      tipMessage: '',
      joinUser: [],
      rechargeModel: false,
      getPrize: false,//不是app登录领取奖品提示
      prizeMessage: {},
      cftj: false,
      timer: null,
      languageList: [],
      swipeConfig: [],
      isShow:true,
      ind:1,
      total:0,
      buySuccess:false,
      observe:{},
      isOpen:false,//是否弹出购买弹框
      loading:true,
      loading1:true,
      loading2:true,
      loading3:true
    }
  },
  created() {
    //  console.log(window.location.origin)
    this.resher();
    if (this.$route.query.isApp == 1) {
      window.gtag('event', '1 USD_click', {button:'1 USD'})
      // this.$firebase.logEvent('1 USD_click',{button:'1 USD'})
      if (this.$route.query.token) {
        // Toast('有token')
        this.askShopStatus()
      }
    } else {
      if (this.token) {
        // console.log(this.token)
        this.askShopStatus()
      }
    }
    this.getHorseLamp();//走马灯
    this.getShopData()//奖品输数据
    this.getPurchaseBanner()
    sessionStorage.setItem('isApp', this.$route.query.isApp)
    // Toast(this.isApp,'fusyiusd')
  },
  computed: {
    ...mapGetters(['token', 'isDirection', 'language'])
  },
  methods: {
    goDetail(item){
      window.gtag("event", "1 USD_select", {item_name:item.title});
      this.$router.push({path:'/prizeDetail',query:{id:item.id,token:this.$route.query.token,isApp:this.$route.query.isApp}})
    },
    showOff(){
          this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appShowOff,
        {
          code: 200,
          title: this.prizeMessage.share||'',
          url:window.location.origin+'/purchase',
          text: this.prizeMessage.highlighting||'',
          join:this.$t('300347')
        },
        data => {}
      );
    },
    getPurchaseBanner(){
      getPurchaseBanner().then(res=>{
        this.swipeConfig = res.data.filter(item => item.image !== '')
        this.loading=false
      })
    },
    lookHistory(){
      if(this.$route.query.isApp==1){
        if(this.$route.query.token){
          this.$router.push({path:'/prizeHistory',query:{token:this.$route.query.token,isApp:this.$route.query.isApp}})
        }else{
          this.appLogin()
        }
      }else{
        if(this.token){
          this.$router.push({path:'/prizeHistory'})
        }else{
          this.$router.push('/login')
        }
      }
    },
    closePrize() {//中将弹框
      this.prizeModel = false;
      sessionStorage.setItem('startTime', new Date() * 1)
    },
    goBack() {
      // console.log(this.$route)
      if (this.$route.query.isApp) {
        removeCookie();
        removeLanguage();
        this.$jsBridge.callHandler(this.$jsBridgeCmd.goBack, {}, data => { });
      } else {
        this.$router.go(-1)
      }
    },
    fixedNum(arg1, arg2) {
      return Methods.numMultiply(Number(arg1), Number(arg2))
    },
    purchaseRecord() {
      if (this.$route.query.isApp == 1) {
        if (this.$route.query.token) {
          this.$router.push({ path: '/prizeHistory', query: { isApp: this.$route.query.isApp, token: this.$route.query.token, language: this.$route.query.language } })
        } else {
          this.appLogin()
        }
      } else {
        if (this.token) {
          this.$router.push('/prizeHistory')
        } else {
          this.appLogin()
        }
      }
    },
    goToGetIt() {
      this.prizeModel = false
      sessionStorage.setItem('startTime', JSON.stringify(new Date() * 1))
      if (this.isApp) {
        this.$jsBridge.callHandler(
          this.$jsBridgeCmd.appCustomerService,
          {
            code: 200,
          },
          data => {
          }
        );
        this.cftj = false
      } else {
        this.getPrize = true;
        this.cftj = false
      }
    },
    rechargeDoller() {
      if (this.$route.query.isApp == 1) {
        if (this.$route.query.token) {
          this.$jsBridge.callHandler(
            this.$jsBridgeCmd.appRecharge,
            {
              code: 200,
              active: window.location.href.toString().split("?")[0]
            },
            data => {
            }
          );
        } else {
          this.appLogin()
        }
      } else {
        if (this.token) {
          this.rechargeModel = true
        } else {
          this.appLogin()
        }
      }
    },
    askShopStatus() {
      askShopStatus().then(res => {
        if (res.data) {
          if (sessionStorage.getItem('startTime') * 1 + 24 * 60 * 60 * 1000 <= new Date() * 1) {

            this.prizeModel = true
          }
          this.prizeMessage = res.data
        }
      })
    },
    handleInput() {
        console.log('看看是这里吗');
      this.num = this.num.replace(/^0(0+)|[^\d]+/g, '');
    },
    closeTips() {
      this.tipsdialog = false
    },
    subtractNum() {
      if (this.num <= 1) return
      this.num--;
    },
    addNum() {
      if (this.num === '') {
        this.num = 1
        return
      }
      this.num++;
    },
    getHorseLamp() {
      getHorseLamp({ type: 1 }).then(res => {
        this.joinUser = res.data;
         this.loading1 = false
      })
      getHorseLamp({ type: 2 }).then(res => {
        this.prizeUser = res.data
        this.loading2 = false
      })
    },
    getShopData() {
      getShopData({ page:this.ind}).then(res => {
        this.shopList = res.data.items;
        this.total = res.data.total
        this.loading3 = false
      })
    },
    buyShop(id) {
      if (this.cftj) return
      document.activeElement.blur();
      this.cftj = true
      this.isOpen = true
      this.show = false
      buyPrizeShop({ mallPrizeId: id, amount: this.num }).then(res => {
        if (res.code === 505) {
          this.tipModel = true;
          this.isOpen = false;
        }
        else if (res.code === 502) {
          this.selled = true;
          this.isOpen = false;
        }
        else if (res.code === 200) {
          this.buySuccess = true
          let timer = setTimeout(() => {
            // this.tipsdialog = true;
            // this.ind = 1;
            // this.layout()
            // this.$router.go(0)
            this.buySuccess = false
            this.isOpen = false;
            clearTimeout(timer)

          }, 2000)
        getShopData({ pageSize:this.ind*10,page:1}).then(res => {
        this.shopList = res.data.items;
        this.total = res.data.total
         })
          // this.getShopData()
        } else {
          // Toast(res.msg)
        }
        this.tipMessage = res.msg
        this.cftj = false
      })
    },
    rechargeBalance() {
      this.tipModel = false;
      if (this.isApp) {
        this.$jsBridge.callHandler(
          this.$jsBridgeCmd.appRecharge,
          {
            code: 200,
            active: window.location.href.toString().split("?")[0]
          },
          data => {
          }
        );
      } else {
        this.rechargeModel = true
      }
    },
    handler(item) {
      if(this.isOpen){return}
      if (this.$route.query.token || this.token) {
        this.shopMessage = item
        // this.shopMessage = res.data
        getUserAssets({ currency: item.currency }).then(resp => {
          this.assetsNum = resp.data
        })
        this.show = true
      } else {
        this.appLogin()
      }
    },
    appLogout() {
      var _this = this;
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appLogout,
        { code: 200 },
        data => {
          _this.isLogin = false;
          removeToken();
          removeCookie("userInfo");
          _this.appLogin();
        }
      );
    },
    resher() {
      // Toast(this.$route.query.token ? "有token-测试用" : "没有token-测试用");
      // Toast(this.$route.query.language)
      this.isApp = this.$route.query.isApp;
      var token = this.$route.query.token;
      if (this.$route.query.isApp == 1) {
        this.$store.dispatch("setisApp", this.$route.query.isApp);
        if(this.$route.query.language){
          this.$store.dispatch('setLanguage',this.$route.query.language)
          //  Toast(`${this.$route.query.language}`)
          getLanguageList().then(res => {
          let el = res.data.find(item => {
            return item.language == this.$route.query.language
          })
          this.$store.dispatch('setLanguageName', el.name)
          this.$i18n.locale =this.$route.query.language;
          this.$store.dispatch(
          "setIsDirection",
          this.$route.query.language == "fa" || this.language == 'fa' ? true : false
      );
         window.document.documentElement.setAttribute(
        "dir",
        this.isDirection ? "rtl" : "ltr"
      );
        })
        }else{
          let language = getCookie('language');
           this.$store.dispatch('setLanguage', language)
          getLanguageList().then(res => {
          let el = res.data.find(item => {
            // console.log(item)
            return item.language == language
          })
          this.$store.dispatch('setLanguageName', el.name)
        })
        this.$i18n.locale = language;
          this.$store.dispatch(
        "setIsDirection",
      language == "fa" || this.language == 'fa' ? true : false
      );
      window.document.documentElement.setAttribute(
        "dir",
        this.isDirection ? "rtl" : "ltr"
      );
        }
        // removeToken()
        if (token) {
          setToken(token);
          this.isLogin = true;
        } else {
          removeToken();
          this.isLogin = false;
        }
      } else {
        this.isLogin = getCookie("token") ? true : false;
        if (this.isLogin) {
        } else {
          removeToken();
        }
      }
      this.$store.dispatch(
        "setIsDirection",
        this.$route.query.language == "fa" || this.language == 'fa' ? true : false
      );
      window.document.documentElement.setAttribute(
        "dir",
        this.isDirection ? "rtl" : "ltr"
      );
    },
    appLogin() {
      if (this.$route.query.isApp == 1) {
        this.$jsBridge.callHandler(
          this.$jsBridgeCmd.appLogin,
          { code: 200, type: "login", url: window.location.href.toString().split("?")[0] },
          data => { }
        );
      } else {
        this.$router.push({ path: '/login', query: { historyBack: '/purchase' } });
      }
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.getHorseLamp();
    }, 30000)
      this.$nextTick(function(){
          let timer = setTimeout(()=>{
      let loading = document.querySelector('.loading-box');
       this.observe = new IntersectionObserver((entries)=>{
        if(entries[0].intersectionRatio>0){
          if(this.shopList.length === this.total){
            this.isShow = false
            this.observe.unobserve(loading)
            return
          }
          this.ind++;
          getShopData({page:this.ind}).then(res=>{
            this.shopList = this.shopList.concat(res.data.items);
            this.total = res.data.total
          })
        }
      })
      this.observe.observe(loading)
      clearTimeout(timer)
    },1000)
      })
  },
  beforeDestroy() {
    this.observe = null
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>
<style lang='scss' scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
[dir="ltr"] {
  .purchase-page {
    .app-down{
      img{
        margin-right: torem(8);
      }
    }
    /deep/ .van-nav-bar__right {
      right: 0;
    }
    /deep/ .van-nav-bar__left {
      left: 0;
    }
    .rate-of-progress{
      left: 0;
    }
    .winners .notice {
      li {
        img {
          margin-right: torem(4);
        }
      }
    }
    .inputBox {
      .subtract {
        border-right: torem(1) solid rgba(188, 188, 188, 1);
      }
      .add {
        border-left: torem(1) solid rgba(188, 188, 188, 1);
      }
    }
  }
}
[dir="rtl"] {
  .purchase-page {
     .app-down{
      img{
        margin-left: torem(8);
      }
    }
    .purchase-header {
      /deep/ .van-nav-bar__left {
        right: 0;
      }
    }
  }
  .rate-of-progress{
    right: 0;
  }
  .winners .notice {
    li {
      img {
        margin-left: torem(4);
      }
    }
  }
  .inputBox {
    .subtract {
      border-left: torem(1) solid rgba(188, 188, 188, 1);
    }
    .add {
      border-right: torem(1) solid rgba(188, 188, 188, 1);
    }
  }
}
</style>
<style lang='scss'>
.van-nav-bar {
  .van-nav-bar__right {
    left: 0 !important;
  }
}
</style>
<style lang="scss" scoped>
@import "../../assets/css/variableName";
@import "../../style/mixin";
.purchase-page {
  .tipsMessage{
    margin-top: torem(20);
   p{
    width: torem(256);
    font-size: torem(12);
    line-height: torem(18);
    text-align: center;
    color: rgba($color: #fff, $alpha: .7);
   }
  }
    /deep/ .header-top{
      position: relative;
    }
    .purchase-toast{
      padding: torem(8) 0 torem(42) 0;
      box-sizing: border-box;
      p{
        color: #fff;
        font-size: torem(16);
        line-height: torem(18);
        margin-top: torem(14);
        width: 100%;
        text-align: center;
      }
        >div{
        width: torem(60)!important;
        height: torem(60)!important;
        }
      position: fixed;
      top: 50%;
      left: 50%;
      z-index: 9999;
      transform: translate(-50%,-50%);
      width: torem(197);
      height: torem(143);
      border-radius: torem(8);
      background: rgba($color: #000000, $alpha: .8);
    }
  .app-down {
    padding: torem(10) torem(24);
    background-color: #fff6dc;
    .download-content {
      p {
        font-size: torem(15);
        color: #40475a;
        margin-bottom: torem(4);
        font-weight: bold;
      }

      span.block {
        font-size: torem(10);
        color: #40475a;
        line-height: torem(11);
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 2; //行数
        line-clamp: 2;
        -webkit-box-orient: vertical; //盒子中内容竖直排列
      }
    }
   dl{
    // width: torem(48);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    dt{
      svg{
        width: torem(24);
        height: torem(24);
      }
    }
    dd{
    width: torem(48);
    color: #40475A;
    font-size: torem(10);
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-top: torem(4);
    line-height: torem(12);
    }
   }
  }

  min-height: 100vh;
  width: 100%;
  .purchase-body {
    // flex: 1;
    // margin-top: torem(44);
    // background: #fff;
    .swiperSkeleton{
      .van-skeleton__row{
      width: 100%!important;
      height: torem(160);
    }
    }
    // /deep/
     background: #f6f8fa;
    .banner {
      width: 100vw;
      padding: torem(37) torem(16) torem(19) torem(16);

      background: linear-gradient(
        to right,
        rgba(255, 199, 43, 0),
        rgba(255, 199, 43, 0.2)
      );
      border-radius: 0 0 torem(16) torem(16);
      margin-bottom: torem(20);
    }
    .productListSkeleton{
      margin-top: torem(24);
      .van-skeleton__row{
        height: torem(500);
        width: 100%!important;
      }
    }
    .swiper-banner {
      direction: ltr;
      width: torem(375);
      height: torem(160);
      // background: #f6f8fa;
      /deep/ .van-swipe {
        height: 100%;
        width: 100%;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      /deep/ .van-swipe__indicator {
        width: torem(5);
        height: torem(5);
        background: rgba(188, 188, 188, 1);
      }
      /deep/ .van-swipe__indicator--active {
        background: #ffc72b;
      }
    }
    .winners {
      width: 100vw;
      padding: 0 torem(12);
       margin-top: torem(24);
       background: #f6f8fa;
      .nav-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: torem(22);
        span {
          &:first-child {
            color: #000922;
            font-size: torem(18);
          }
          &:last-child {
            color: #40475a;
            font-size: torem(14);
          }
        }
      }
      .notice {
        margin-top: torem(12);
        /deep/ .purchase_out_box {
          height: torem(30);
        }
        li {
          height: torem(30);
          padding: 0 torem(16);
          border-radius: torem(18);
          height: torem(30);
          line-height: torem(30);
          flex-shrink: 0;
          display: flex;
          align-items: center;
          font-size: torem(14);
          margin: 0 torem(4);
          img {
            width: torem(14);
            height: torem(14);
          }
        }
        &-lamp2 {
          margin-top: torem(8);
        }

        width: torem(343);
        .trotting-horse-lamp1 {
          display: flex;
          flex-wrap: nowrap;
          height: torem(30);
          li {
            background: #f34e74;
            color: #fff;
          }
        }
        .lamp2Skeleton,.lamp1Skeleton{
          .van-skeleton__row{
              height: torem(30);
          width: 100%!important;
          }

        }

        .trotting-horse-lamp2 {
          display: flex;
          flex-wrap: nowrap;
          height: torem(30);
          li {
            background: #ffc72b;
            color: #000922;
          }
        }
      }
    }
    .loading-box{
        position: absolute;
        width: 100%;
        height: torem(50);
        left: 50%;
        transform: translateX(-50%);
        .loading{
        width: 100%;
        bottom: 0;
        height: torem(50);
           &::before{
          border-top-color: #ccc;
        }
        }
      }
    .product-list {
      margin: torem(24) auto 0;
      // padding: 0 torem(12);
      // column-count: 2;
      // column-gap: torem(9);
      // column-width: torem(171);

      height: 100%;
      width: torem(352);
      justify-content: space-between;
      flex-wrap: wrap;
      display: flex;
      // position: relative;
      .current-price {
        font-size: torem(12);
        margin-top: torem(12);
        color: #f34e74;
        line-height: torem(16);
        span {
          font-size: torem(16);
        }
      }
      .old-price {
        font-size: torem(10);
        color: #999999;
        margin-top: torem(4);
        text-decoration: line-through;
      }
      .van-button {
        width: torem(144);
        height: torem(40);
        background: #ffc72b;
        font-size: torem(16);
        margin-top: torem(8);
        border-radius: torem(4);
        box-sizing: border-box;
      }
      .product-title {
        font-size: torem(16);
        line-height: torem(21);
        // height: torem(40);
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 2; //行数
        line-clamp: 2;
        -webkit-box-orient: vertical; //盒子中内容竖直排列
      }
      .product-outbox{
        width: torem(176);
        padding-bottom:torem(8);
        background: transparent;
        box-sizing: border-box;
      }
      .product-item{
        margin: 0 auto;
        border-radius: torem(8);
          box-shadow: torem(1) torem(1) torem(1) torem(0) rgba(0, 0, 0, 0.08);
        // border: torem(0.5) solid #efefef;
        display: flex;
        flex-direction: column;
        width: torem(168);
        background: #fff;
        .shop-describe {
            .alignBtn {
            background: #f34e74;
           color: #ffffff;
             }
          padding: torem(12) torem(12) torem(16);
          .progress-bar{
            width: torem(147);
            height: torem(6);
            border-radius: torem(3);
            margin: torem(12) auto;
            background: #F3F1EE;
            position: relative;
            overflow: hidden;
          }
          .rate-of-progress{
            height: 100%;
            position: absolute;
            top: 0;
            width: 0;
            border-radius:torem(3);
            background: #ffc72b;
            transition: width 3s linear;
          }
        }
        img {
          border-radius: torem(8);
          width: 100%;
          object-fit: contain;
          height: 100%;
          // height: torem(171);
          // width: torem(171);
        }
      }
    }
  }
}
.form-popup {
  text-align: center;
  .buy {
    // width: fit-content;
    // margin: 0 auto;
    text-align: center;
  }
  /deep/ .van-button {
    width: torem(311);
    height: torem(50);
    background: #ffc72b;
    font-size: torem(16);
    border-radius: torem(4);
    //   margin: 0 auto;
  }
  .Copies {
    span {
      font-size: torem(16);
    }
    i {
      font-size: torem(12);
    }
  }
  .price {
    display: inline-block;
    width: torem(311);
    font-size: torem(14);
    color: rgba(127, 132, 144, 1);
    margin: torem(24) 0;
    line-height: torem(16);
    text-align: center;
    // span {
    //   color: #fa4d56;
    // }
  }
  .inputBox {
    width: torem(280);
    height: torem(64);
    box-sizing: border-box;
    display: flex;
    margin: 0 auto;
    border: torem(1) solid rgba(188, 188, 188, 1);
    border-radius: torem(4);
    .disable {
      color: #bcbcbc;
    }
    span {
      font-size: torem(24);
      width: torem(50);
      line-height: torem(64);
      // height: torem(64);
      vertical-align: middle;
      text-align: center;
    }

    .input {
      width: torem(190);
      padding: torem(10) 0;
      box-sizing: border-box;
      p {
        text-align: center;
        color: rgba(0, 9, 34, 1);
        font-size: torem(12);
        &:nth-child(1) {
          input {
            width: torem(70);
            font-size: torem(24);
            font-weight: 500;
            text-align: center;
          }
        }
        &:nth-child(2) {
          margin-top: torem(4);
          color: rgba(127, 132, 144, 1);
          font-size: torem(12);
        }
      }
    }
  }
}
.prizeDescribe {
  min-height: torem(40);
  width: torem(268);
  background: rgba(255, 199, 43, 0.2);
  border-radius: torem(20);
  padding: torem(6) torem(16);
  margin: torem(24) auto;
  font-size: torem(12);
  p {
    line-height: torem(14);
    color: #000922;
    text-align: center;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  //   vertical-align: middle;
}

/deep/ .van-notice-bar__wrap {
  height: torem(40);
}
.notice-lamp2 {
  /deep/ .van-notice-bar {
    margin-top: torem(8);
    padding: 0;
  }
}
.notice-lamp1 {
  /deep/ .van-notice-bar {
    margin-top: torem(3);
    padding: 0;
  }
}
.form-popup {
  // /deep/ .van-popup {
  min-height: torem(336);
  border-radius: torem(16) torem(16) 0 0;
  padding: torem(24) torem(16) torem(16);
  box-sizing: border-box;
  // }
}

.tipModel {
  // /deep/ .van-popup {
  width: torem(312);
  min-height: torem(204);
  border-radius: torem(8);
  padding: torem(24);
  // display: flex;
  // justify-content: space-between;
  // flex-direction: column;
  // align-items: center;
  // }
  .p {
    text-align: center;
    svg {
      width: torem(48);
      height: torem(48);
    }
  }
  .describe {
    font-size: torem(16);
    // margin: 0 torem(16);
    text-align: center;
    height: torem(24);
    line-height: torem(24);
    width: 100%;
    margin: torem(16) 0 torem(24);
  }
  .recharge {
    font-size: torem(14);
    width: 100%;
    line-height: torem(21);
    height: torem(21);
    margin: torem(16) 0 torem(24);
    text-align: center;
  }
  .sell {
    /deep/ .van-button {
      width: torem(264);
      height: torem(44);
      background: #ffc72b;
      border-radius: torem(4);
      font-size: torem(16);
      color: #000922;
    }
  }
  .btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    /deep/ .van-button {
      width: torem(128);
      >div{
        padding: 0 torem(6);
      box-sizing: border-box;
      }

     span{
       word-wrap: break-word; /*强制换行*/
      // overflow: hidden; /*超出隐藏*/
      // text-overflow: ellipsis;/*隐藏后添加省略号*/
      // white-space: nowrap;/*强制不换行*/
      line-height: torem(20);
      text-align: center;
     }
      height: torem(44);
      line-height: torem(44);
      padding: 0;
      border-radius: torem(4);
      background: rgba(234, 236, 239, 1);
      font-size: torem(16);
      &:nth-child(2) {
        background: rgba(255, 199, 43, 1);
      }
    }
  }
}
.prizeModel {
  background: transparent;
  .close {
    text-align: center;
    svg {
      width: torem(28);
      height: torem(28);
      margin: 0 auto;
      // text-align: center;
      margin-top: torem(21);
    }
  }

  .p {
    text-align: center;
    img {
      width: torem(14);
      height: torem(14);
      margin: 0 torem(8);
    }
    font-size: torem(14);
    background: linear-gradient(to right, #d3f6ff, #fffbc9);
    -webkit-background-clip: text;
    color: transparent;
  }
  .shopName {
    font-size: torem(20);
    line-height: torem(23.44);
    background: linear-gradient(to right, #d3f6ff, #fffbc9);
    -webkit-background-clip: text;
    color: transparent;
    text-align: center;
    margin-top: torem(4);
    margin-bottom: torem(24);
  }
  .prizeImage {
    width: torem(278);
    height: torem(211.75);
    img {
      width: torem(278);
      height: torem(211.75);
    }
  }
  .btn {
    // text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: torem(47);
    min-height: torem(50);
    >span{
      display: inline-block;
      margin-top: torem(20);
      line-height: torem(16);
      font-size: torem(16);
      color: #fff;
    }
    flex-shrink: 0;
    .van-button {
      width: torem(257);
      height: torem(50);
      // height: 100%;
      font-size: torem(16);
      // line-height: torem(50);
      color: #000922;
      // background: transparent;
      border: none;
      background: url("../../../static/images/btnbackground.png") no-repeat;
      background-size: 100% 100%;
      border-radius: torem(4);
    }
  }
}
.van-button {
  border: none;
}
/deep/ .van-overlay{
  height: 100vh;
  position: fixed;
  top: 0;
}
/deep/ .van-popup--center{
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
</style>



// WEBPACK FOOTER //
// src/view/purchase/index.vue